import graphqlClient from '../../../apollo'
import gql from 'graphql-tag'

const MY_EFFECTIVE_PERMISSIONS = gql`
  query myEffectivePermissions {
    myEffectivePermissions
  }
`

class EffectivePermissionsProvider {
  fetchEffectivePermissions() {
    return graphqlClient.query({
      query: MY_EFFECTIVE_PERMISSIONS,
      fetchPolicy: 'network-only',
    })
  }
}

export default new EffectivePermissionsProvider()
